import React from 'react';
import PropTypes from 'prop-types'

import '../AssociatesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import BackLink from '../../../components/library/common/BackLink';

const AssociatesPageHeader = ({ firstName }) => {
    return (
        <div className='columns'>
            <div className='column is-8 is-offset-1 homePageHeader' >
                <h1 className='page-title'>
                    <HrbTranslate text='AssociatesPage.Labels.Hi' params={{ FirstName: firstName }} />
                </h1>
            </div>
            <div className='column is-2'>
                <BackLink isRight />
            </div>
        </div>
    )
}

AssociatesPageHeader.propTypes = {
    firstName: PropTypes.string
}

export default AssociatesPageHeader